import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, CadastrarMotivoRequest } from './types';

// ACTIONS
import { cadastrarMotivoSuccess, cadastrarMotivoFailure } from './actions';

function* cadastrarMotivo(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: CadastrarMotivoRequest } = request;

	const body = { ...payload, id: payload.id || payload.codigo };

	delete body.codigo;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_SGU_API,
		`motivos`,
		body,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastrarMotivoSuccess(response));
	} else {
		yield put(cadastrarMotivoFailure());
	}
}

export default all([takeLatest(Types.CADASTRAR_MOTIVO, cadastrarMotivo)]);
